import { observer } from 'mobx-react-lite';
import { FC, PropsWithChildren } from 'react';

import { useCallContext } from '@gem/call/CallView/CallView.context';
import { FullScreenButton } from '@gem/call/CallView/Shared/FullScreenButton/FullScreenButton';
import { PermissionRequestButton } from '@gem/call/CallView/Shared/PermissionRequestsButton/PermissionRequestButton';
import { RecordingPlaceholder } from '@gem/call/CallView/Shared/RecordingPlaceholder/RecordingPlaceholder';
import { ShowMoreButton } from '@gem/call/CallView/Shared/ShowMoreButton/ShowMoreButton';

import styles from './CompactCallViewHeader.styles.m.css';

export const CompactCallViewHeader: FC<PropsWithChildren> = observer(({ children }) => {
  const { call } = useCallContext();

  const canShowPermissionsRequestsButton =
    call?.isMeInitiatorOwnerOrAdmin && !call.isPermissionsRequestsEmpty;

  return (
    <div className={styles.container}>
      {children}
      {call?.isRecording && <RecordingPlaceholder />}
      {canShowPermissionsRequestsButton && <PermissionRequestButton />}
      {!call?.isUnauthorizedCall && <FullScreenButton className={styles.button} />}
      <ShowMoreButton className={styles.button} />
    </div>
  );
});
